import styled, { css } from 'styled-components';
import { shadows, colors } from 'style/theme';

export const Container = styled.div`
  color: ${colors.white};
`;

const sharedCircleStyle = css`
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 15px;
  border: 1px solid #fff;
  border-radius: 50%;
  box-shadow: ${shadows.small};
`;

export const GreenCircle = styled.div`
  background-color: ${colors.chateauGreen};
  ${sharedCircleStyle};
`;

export const YellowCircle = styled.div`
  background-color: ${colors.yellow};
  ${sharedCircleStyle};
`;

export const RedCircle = styled.div`
  background-color: ${colors.red};
  ${sharedCircleStyle};
`;

export const Point = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: inherit;
  font-size: 16px;
  font-weight: normal;

  :not(:last-child) {
    margin-bottom: 16px;
  }

  > :last-child {
    flex: 1;
  }
`;
